import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "live-region",
  class LiveRegion extends WYATTElement {
    constructor() {
      super();

      if (!this.ariaLive) {
        this.ariaLive = "polite";
      }
    }

    connectedCallback() {
      this.subscribe(
        WYATT.PubSub.events.updateDOM,
        this.conditionallyUpdateDOM.bind(this),
      );
    }

    conditionallyUpdateDOM(event) {
      const data = event?.detail;

      if (!data) {
        return;
      }

      const item = data.find(
        ({ liveRegion }) => liveRegion === this.dataset.liveRegion,
      );

      if (item) {
        const newDOM = new DOMParser()
          .parseFromString(item.html, "text/html")
          .querySelector(`[data-live-region="${this.dataset.liveRegion}"]`);

        if (!newDOM) {
          return;
        }

        this.updateDOM.replaceWith(this, newDOM);
      }
    }
  },
);
